var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavoriteIcon = function SvgFavoriteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M2.95 3.369c1.62-1.33 3.262-1.606 4.719-1.314 1.484.299 2.826 1.2 3.757 2.303l.574.679.573-.68c.934-1.107 2.248-2.005 3.713-2.302 1.435-.29 3.08-.02 4.763 1.312 1.14.95 2.242 2.7 2.2 4.999-.042 2.29-1.226 5.264-4.934 8.64l-.01.01-.011.01a51 51 0 0 1-3.395 3.005 26 26 0 0 1-1.845 1.377c-.448.297-.804.494-1.054.599-.25-.105-.606-.302-1.054-.599a26 26 0 0 1-1.845-1.377 51 51 0 0 1-3.395-3.005l-.01-.01-.01-.01-.341-.315C1.905 13.445.792 10.585.75 8.366c-.042-2.297 1.06-4.047 2.198-4.997Z"
  })));
};
export default SvgFavoriteIcon;